module.exports = __webpack_public_path__ + "img/jiayou.35633963.svg";